/**
 * Utility to convert country code to flag emoji
 */

// Convert 2-letter ISO country code to flag emoji
export const countryCodeToFlag = (countryCode) => {
  if (!countryCode || countryCode.length !== 2) return null;
  
  const code = countryCode.toUpperCase();
  const offset = 127397; // Regional Indicator Symbol offset
  
  try {
    const flag = String.fromCodePoint(
      code.charCodeAt(0) + offset,
      code.charCodeAt(1) + offset
    );
    return flag;
  } catch (e) {
    return null;
  }
};

// Get flag for a country name (fallback lookup)
const COUNTRY_NAME_TO_CODE = {
  "united states": "US",
  "usa": "US",
  "united kingdom": "GB",
  "uk": "GB",
  "france": "FR",
  "germany": "DE",
  "spain": "ES",
  "italy": "IT",
  "japan": "JP",
  "china": "CN",
  "australia": "AU",
  "canada": "CA",
  "brazil": "BR",
  "mexico": "MX",
  "india": "IN",
  "russia": "RU",
  "south korea": "KR",
  "netherlands": "NL",
  "sweden": "SE",
  "norway": "NO",
  "denmark": "DK",
  "finland": "FI",
  "switzerland": "CH",
  "austria": "AT",
  "belgium": "BE",
  "portugal": "PT",
  "greece": "GR",
  "ireland": "IE",
  "new zealand": "NZ",
  "singapore": "SG",
  "thailand": "TH",
  "vietnam": "VN",
  "indonesia": "ID",
  "malaysia": "MY",
  "philippines": "PH",
  "south africa": "ZA",
  "egypt": "EG",
  "morocco": "MA",
  "turkey": "TR",
  "argentina": "AR",
  "chile": "CL",
  "colombia": "CO",
  "peru": "PE",
  "jamaica": "JM",
  "cuba": "CU",
  "dominican republic": "DO",
  "costa rica": "CR",
  "panama": "PA",
  "bahamas": "BS",
  "barbados": "BB",
  "trinidad and tobago": "TT",
  "iceland": "IS",
  "poland": "PL",
  "czech republic": "CZ",
  "czechia": "CZ",
  "hungary": "HU",
  "croatia": "HR",
  "romania": "RO",
  "bulgaria": "BG",
  "serbia": "RS",
  "ukraine": "UA",
  "uae": "AE",
  "united arab emirates": "AE",
  "saudi arabia": "SA",
  "israel": "IL",
  "qatar": "QA",
  "kuwait": "KW",
  "oman": "OM",
  "bahrain": "BH",
  "jordan": "JO",
  "lebanon": "LB",
  "maldives": "MV",
  "sri lanka": "LK",
  "nepal": "NP",
  "bangladesh": "BD",
  "pakistan": "PK",
  "kenya": "KE",
  "tanzania": "TZ",
  "nigeria": "NG",
  "ghana": "GH",
  "senegal": "SN",
  "ethiopia": "ET",
  "rwanda": "RW",
  "uganda": "UG",
  "mauritius": "MU",
  "seychelles": "SC",
  "fiji": "FJ",
  "bora bora": "PF",
  "french polynesia": "PF",
  "hawaii": "US",
  "puerto rico": "PR",
  "hong kong": "HK",
  "macau": "MO",
  "taiwan": "TW",
  "mongolia": "MN",
  "cambodia": "KH",
  "laos": "LA",
  "myanmar": "MM",
  "burma": "MM",
};

export const getCountryFlag = (countryCode, countryName) => {
  // Try country code first
  if (countryCode) {
    const flag = countryCodeToFlag(countryCode);
    if (flag) return flag;
  }
  
  // Fallback to name lookup
  if (countryName) {
    const code = COUNTRY_NAME_TO_CODE[countryName.toLowerCase()];
    if (code) {
      return countryCodeToFlag(code);
    }
  }
  
  return null;
};

export default countryCodeToFlag;
